// User session management utility
export interface UserPermissions {
  allow_push_notification?: boolean;
  allow_banner_for_application?: boolean;
  [key: string]: any; // Allow for additional permissions
}

export interface LoggedUserDetails {
  id: number;
  login: string;
  user_type: number;
  user_level: number;
  id_reseller: number;
  reseller4_id: number;
  admin_id: number;
  email: string;
  permission: UserPermissions;
  status: number;
  resellerInfo: {
    balance: string;
    creditLimit: string;
    limit_pins: number;
  };
  reseller: {
    balance: string;
    rate_plan_id: number;
    full_name: string;
  };
}

const USER_SESSION_KEY = 'loggedUserDetails';

export const userSessionService = {
  // Save user details to localStorage
  saveUserDetails: (userDetails: LoggedUserDetails): void => {
    try {
      localStorage.setItem(USER_SESSION_KEY, JSON.stringify(userDetails));
    } catch (error) {
      console.error('Error saving user details to localStorage:', error);
    }
  },

  // Get user details from localStorage
  getUserDetails: (): LoggedUserDetails | null => {
    try {
      const userDetailsStr = localStorage.getItem(USER_SESSION_KEY);
      if (userDetailsStr) {
        return JSON.parse(userDetailsStr) as LoggedUserDetails;
      }
      return null;
    } catch (error) {
      console.error('Error retrieving user details from localStorage:', error);
      return null;
    }
  },

  // Clear user details from localStorage
  clearUserDetails: (): void => {
    try {
      localStorage.removeItem(USER_SESSION_KEY);
    } catch (error) {
      console.error('Error clearing user details from localStorage:', error);
    }
  },

  // Check if user is logged in
  isLoggedIn: (): boolean => {
    return userSessionService.getUserDetails() !== null;
  },

  // Get specific user property
  getUserProperty: <K extends keyof LoggedUserDetails>(property: K): LoggedUserDetails[K] | null => {
    const userDetails = userSessionService.getUserDetails();
    return userDetails ? userDetails[property] : null;
  },
};
